import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import {
  PeopleFill,
  FileText,
  CreditCard,
  ExclamationTriangle,
  Wrench,
  Key,
  Gear
} from 'react-bootstrap-icons';
import './Admin.css';

const DashboardOverview = ({ userCount, onSectionChange }) => {
  // Dashboard Cards Data
  const dashboardCards = [
    {
      id: 'users',
      title: 'User Management',
      description: 'Manage user accounts, roles, and subscriptions',
      icon: <PeopleFill size={24} />,
      count: userCount,
      color: 'primary',
      onClick: () => onSectionChange('users')
    },
    {
      id: 'reports',
      title: 'Report Management',
      description: 'Create and manage research reports',
      icon: <FileText size={24} />,
      color: 'success',
      onClick: () => onSectionChange('reports')
    },
    {
      id: 'pricing',
      title: 'Pricing Plans',
      description: 'Configure subscription plans and pricing',
      icon: <CreditCard size={24} />,
      color: 'warning',
      onClick: () => onSectionChange('pricing')
    },
    {
      id: 'setup',
      title: 'One-Time Data Setup',
      description: 'Initialize database with essential data',
      icon: <Wrench size={24} />,
      color: 'info',
      onClick: () => onSectionChange('setup')
    },
    {
      id: 'complaints',
      title: 'Complaints Data',
      description: 'View and manage customer complaints',
      icon: <ExclamationTriangle size={24} />,
      color: 'danger',
      onClick: () => onSectionChange('complaints')
    },
    {
      id: 'external-api',
      title: 'External API Keys',
      description: 'Manage third-party API access for user status checks',
      icon: <Key size={24} />,
      color: 'primary',
      onClick: () => onSectionChange('external-api')
    },
    {
      id: 'settings',
      title: 'App Settings',
      description: 'Feature flags and application-level toggles',
      icon: <Gear size={24} />,
      color: 'secondary',
      onClick: () => onSectionChange('settings')
    }
  ];

  return (
    <div className="admin-dashboard-overview">
      <Row className="g-4">
        {dashboardCards.map((card) => (
          <Col key={card.id} xs={12} sm={6} lg={4}>
            <Card 
              className={`admin-dashboard-card admin-dashboard-card-${card.color} h-100`}
              onClick={card.onClick}
            >
              <Card.Body className="text-center">
                <div className={`admin-card-icon admin-card-icon-${card.color} mb-3`}>
                  {card.icon}
                </div>
                <Card.Title className="h5 mb-2">{card.title}</Card.Title>
                <Card.Text className="text-muted small mb-3">{card.description}</Card.Text>
                {card.count !== undefined && (
                  <div className={`admin-card-count admin-card-count-${card.color}`}>
                    {card.count}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DashboardOverview; 